var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "17px",
    viewBox: "0 0 26 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.03125 C0,15.704347 0.545652961,16.25 1.21875,16.25 C1.89184704,16.25 2.4375,15.704347 2.4375,15.03125 L2.4375,1.21875 C2.4375,0.545652961 1.89184704,0 1.21875,0 C0.545652961,0 0,0.545652961 0,1.21875 L0,15.03125 Z M12.741625,1.9825 C13.2168617,2.45832851 13.2168617,3.22917149 12.741625,3.705 L9.540375,6.90625 L24.78125,6.90625 C25.454347,6.90625003 25.9999999,7.45190298 25.9999999,8.125 C25.9999999,8.79809702 25.454347,9.34374997 24.78125,9.34375 L9.540375,9.34375 L12.741625,12.545 C13.0676864,12.8488272 13.2019049,13.3064028 13.0916265,13.7382195 C12.9813481,14.1700362 12.6441612,14.5072231 12.2123445,14.6175015 C11.7805278,14.7277799 11.3229522,14.5935614 11.019125,14.2675 L5.73625,8.98625 L4.875,8.125 L5.73625,7.26375 L11.0175,1.9825 C11.2460824,1.75377108 11.5561946,1.62526019 11.8795625,1.62526019 C12.2029304,1.62526019 12.5130426,1.75377108 12.741625,1.9825 L12.741625,1.9825 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.81be6f466c29301a7667043063cd56ae.svg";
export { ForwardRef as ReactComponent };